import "./Rooms.scoped.scss"
import Room from "./Room";
import { useRecoilState } from "recoil";
import roomsState from "../../atoms/rooms";
import moment from "moment";
import waitingRoomState, { RoomsSortingType } from "../../atoms/waiting-room";

function Rooms() {
  const [rooms] = useRecoilState(roomsState);
  const [waitingRoom] = useRecoilState(waitingRoomState);

  let allRooms = rooms.filter((room) => room.id !== '' && room.id !== 'square');
  let projectRooms = allRooms.filter((room) => room.isProject);
  let normalRooms = allRooms.filter((room) => !room.isProject);

  
  // Sorting handling
  if (waitingRoom.roomsSorting === RoomsSortingType.SORT_IN_NEWER) {
    projectRooms = projectRooms.reverse();
    normalRooms = normalRooms.reverse();
  } else if (waitingRoom.roomsSorting === RoomsSortingType.SORT_IN_PARTICIPANTS) {
    projectRooms.sort((a, b) => b.uniqueParticipants - a.uniqueParticipants);
    normalRooms.sort((a, b) => b.uniqueParticipants - a.uniqueParticipants);
  } else if (waitingRoom.roomsSorting === RoomsSortingType.SORT_IN_RECOMMENDERS) {
    projectRooms.sort((a, b) => b.recommenders.length - a.recommenders.length);
    normalRooms.sort((a, b) => b.recommenders.length - a.recommenders.length);
  } else if (waitingRoom.roomsSorting === RoomsSortingType.SORT_IN_SCORE) {
    const getScore = (win: number, defeat: number) => {
      const totalRound = win + defeat;
      return totalRound > 10 ? 10000 * win / totalRound : win;
    };
    projectRooms.sort((a, b) => getScore(b.record.win, b.record.defeat) - getScore(a.record.win, a.record.defeat));
    normalRooms.sort((a, b) => getScore(b.record.win, b.record.defeat) - getScore(a.record.win, a.record.defeat));
  } else if (waitingRoom.roomsSorting === RoomsSortingType.SORT_IN_GIFTED_BULLETS) {
    projectRooms.sort((a, b) => b.giftedBullets - a.giftedBullets);
    normalRooms.sort((a, b) => b.giftedBullets - a.giftedBullets);
  }
  const sortedRooms = [...projectRooms, ...normalRooms];

  const thumbnailUrlTailer = Math.floor(moment().unix() / 60);

  return (
    <div className="rooms">
      {sortedRooms.map((room, index) => {
        const thumbnailUrl = room.ownerDetail.hasThumbnail
        ? `/data/member_image/${room.owner.substring(0, 2)}/${room.owner}.gif?${thumbnailUrlTailer}`
        : '/img/profile.png';

        return (
          <Room 
            key={index}
            thumbnailUrl={thumbnailUrl}
            name={room.name}
            participants={room.uniqueParticipants}
            maxParticipants={room.maxParticipants}
            ownerLevel={room.ownerDetail.level}
            ownerName={room.ownerDetail.nickname}
            roomId={room.id}
            isSecret={room.isSecret}
            isProject={room.isProject}
            projectStatus={room.projectStatus}
            projectPrice={room.projectPrice}
            projectType={room.projectType}
            projectStartAmount={room.projectStartAmount}
            projectTargetAmount={room.projectTargetAmount}
            projectAmount={room.projectAmount}
            projectParticipants={room.projectParticipants}
            record={room.record}
            ownerDecorationItem={room.ownerDetail.decorationItem}
            ownerMaxStreak={room.ownerDetail.maxStreak}
            recommendersCount={room.recommenders.length}
          />
        )
      })}
    </div>
  );
}

export default Rooms;
